export const isGeolock = ({ geolock = [], countryCode = 'US' }) => {
  if (geolock[0]) {
    const {
      isGeolock,
      type,
      by,
      countries,
      regions,
      additionalCountries,
      removeCountries,
    } = geolock[0]

    if (!isGeolock) {
      return null
    }

    const regionsList = regions.join(',').split(',')
    const filteredRegions = regionsList.filter(
      (country) => !removeCountries.includes(country)
    )
    const allRegions = [...filteredRegions, ...additionalCountries]

    const blockList = by === 'country' ? countries : allRegions

    const isBlocked =
      type === 'block'
        ? blockList.includes(countryCode)
        : !blockList.includes(countryCode)

    return isBlocked
  }

  return undefined
}
